import InnerComponent from '@Components/Inventory/DeliveryChallan/DeliveryChallanForm';
import orgContainer from '@Components/AppContainer';

const CreateDeliveryChallan = () => ((orgContainer(InnerComponent)));
export default CreateDeliveryChallan;
